export default __webpack_public_path__ + "static/media/ZeroButtonHover.5377abf5.svg";